export const HomeRoutes = {
	Home: '/',
	PrivacyPolicy: '/privacy-policy',
	EndUserAgreement: '/end-user-agreement',
	PaymentTerm: '/payment-term',
};
